/**
 * Axios API Configuration
 */

import axios from 'axios';
import secureStorage from '../utils/secureStorage';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 300000, // 5 minutes timeout for symbol downloads
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Get JWT token from secure storage
    const authData = secureStorage.getItem('authData');
    const token = authData?.token;
    
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Unauthorized - show alert and clear session
      const errorMsg = error.response?.data?.error || 'Your session has expired. Please login again.';
      
      // Only show alert if not already on login page
      if (!window.location.pathname.includes('/login')) {
        alert(errorMsg);
      }
      
      // Clear session and redirect to login
      secureStorage.clear();
      localStorage.clear();
      
      // Don't clear sessionStorage - preserve some settings
      // sessionStorage.clear();
      
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    } else if (error.response?.status === 429) {
      // Rate limit exceeded
      console.warn('Rate limit exceeded. Please slow down.');
    }
    return Promise.reject(error);
  }
);

export default api;
